
<script>
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import SwitchButton from '../components/SwitchButton';


export default {
    components: {
        Navbar,
        Footer,
        Loader,
        SwitchButton,
    },

    data() {
        return {
            pageID: 1,
            newDeal: {
                type: 'Deal',
                title: '',
                description: '',
                currentPrice: 0,
                bestPrice: 0,
                imageURL: "",
                category_id: null
            },
            isLoading: false,
            isLoadingDomain: false,
            domainErrors: [],
            freeDelivery: false,
            freeDeliveryWithMembership: false,
            clickAndCollect: false,
            categories: [],
            ApiDealData: {},
        };
    },

    computed: {
        remainingCharacters() {
            return 120 - this.newDeal.title.length;
        },

        missingDescriptionCharacters() {
            return 120 - this.newDeal.description.length;
        },
    },
    async created() {
        this.categories = await this.getCategories();
        // const idxOfGeneral = this.categories.findIndex(obj => obj.title === 'General');

        // this.setCategory(this.categories[idxOfGeneral].id);
    },

    methods: {

        /**
         * Make sure the domain is amongst the allowed ones.
         */
        async validateDomain() {
            this.isLoadingDomain = true;
            this.domainErrors = [];

            try {
                const da = await window.axios.post(
                    '/api/validate',
                    { url: this.newDeal.url, type: 'Deal' },
                );
                this.ApiDealData = da.data;
                if (this.ApiDealData) {
                    let savings = this.ApiDealData.ItemsResult.Items[0].Offers?.Listings[0]?.Price?.Savings?.Amount ?? false;
                    let price = this.ApiDealData.ItemsResult.Items[0].Offers?.Listings[0]?.Price?.Amount ?? 0;

                    let rrp = 0
                    if (savings) {
                        rrp = savings + price;
                        rrp = rrp.toFixed(2);
                    }
                    this.newDeal.title = this.ApiDealData.ItemsResult.Items[0].ItemInfo.Title.DisplayValue ?? '';
                    this.newDeal.title = this.newDeal.title.substring(0,120);
                    this.newDeal.rrp = rrp ?? 0;
                    this.newDeal.current_price = price ?? 0;
                    this.newDeal.description = this.ApiDealData.ItemsResult.Items[0].ItemInfo.Features?.DisplayValues.join(' ') ?? '';
                    this.newDeal.imageURL = this.ApiDealData.ItemsResult.Items[0].Images.Primary.Large.URL ?? '';
                }
                this.pageID = 2;
            } catch (error) {
                console.log(error);
                for (let err in error.response.data.errors) {
                    Vue.toasted.show(
                        error.response.data.errors[err],
                        { duration: 6000, icon: 'error' },
                    );
                }
            } finally {
                this.isLoadingDomain = false;
            }
        },


        /**
         * Submit the deal to the portal
         */
        async postDeal() {
            this.isLoading = true;
            this.newDeal.collection_charge = 0;

            // Set collection_charge as 1 if free delivery with membership
            if (this.freeDeliveryWithMembership) {
                this.newDeal.collection_charge = 1;
            }

            // Set collection_charge as -1 if free delivery for all.
            if (this.freeDelivery) {
                this.newDeal.collection_charge = -1;
            }

            if (this.clickAndCollect) {
                this.newDeal.click_and_collect = true;
            }


            try {
                const formData = new FormData();
                if (!this.newDeal.rrp) delete this.newDeal.rrp;
                if (!this.newDeal.voucher_code) delete this.newDeal.voucher_code;
                if (!this.newDeal.category_id) delete this.newDeal.category_id;
                Object.keys(this.newDeal).forEach((key) => formData.append(key, this.newDeal[key]));


                const response = await window.axios.post(
                    '/api/deals',
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' } },
                );
                let title = this.newDeal.title.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();

                this.$router.push(`/deal/${response.data.data.id}/${title}`);
            } catch (error) {
                if (error.response && error.response.status === 413) {
                    Vue.toasted.show(
                        'The deal image should be smaller than 1MB',
                        { duration: 6000, icon: 'error' },
                    );
                }

                for (let err in error.response.data.errors) {
                    Vue.toasted.show(
                        error.response.data.errors[err],
                        { duration: 6000, icon: 'error' },
                    );
                }

            } finally {
                this.isLoading = false;
            }
        },

        setImage(event) {
            [this.newDeal.image] = event.target.files;
        },

        setCategory(itemId) {
            console.log(itemId);
            this.newDeal.category_id = itemId;
        },

        async getCategories() {
			const response = await window.axios.get('/api/categories/');
            return response.data.data;
		},
    },

};
</script>

<template lang="pug" src="./templates/ShareDeal.pug"></template>
<style lang="stylus" src="./styles/ShareDeal.styl" scoped></style>
